export const BODY_REGIONS = [
  'Neck',
  'Shoulders',
  'Scapulas',
  'Upper back',
  'Head',
  'Lower back',
  'Hips',
  'Arms',
  'Hands',
  'Legs',
  'Feet',
  'Other',
] as const;

export const PAIN_TYPES = [
  'Aching',
  'Sharp',
  'Burning',
  'Tingling',
  'Pressure',
  'Throbbing',
  'Tight',
  'Stabbing',
] as const;

export const INTERVENTION_TYPES = [
  'TENS',
  'Naproxen',
  'Acetaminophen',
  'Heat',
  'Cold',
  'PT',
  'Rest',
] as const;

export type EnteredBy = 'self' | 'caregiver';
export type WeatherStatus = 'pending' | 'complete' | 'unavailable';

export type Intervention = {
  id: string;
  type: (typeof INTERVENTION_TYPES)[number];
  beforePain: number;
  afterPain: number | null;
  startedAtUtc: string;
  completedAtUtc: string | null;
};

export type WeatherContext = {
  status: WeatherStatus;
  temperatureC: number | null;
  apparentTemperatureC: number | null;
  pressureHpa: number | null;
  weatherCode: number | null;
  observedAtUtc: string | null;
};

export type PainEntry = {
  id: string;
  occurredAtUtc: string;
  timezone: string;
  timezoneOffsetMinutes: number;
  painLevel: number;
  bodyRegions: string[];
  otherBodyRegion: string;
  painTypes: string[];
  enteredBy: EnteredBy;
  notes: string;
  interventions: Intervention[];
  weather: WeatherContext;
  createdAtUtc: string;
  updatedAtUtc: string;
  version: number;
  syncStatus?: 'queued';
};

export type NewPainEntry = Pick<
  PainEntry,
  | 'id'
  | 'occurredAtUtc'
  | 'timezone'
  | 'timezoneOffsetMinutes'
  | 'painLevel'
  | 'bodyRegions'
  | 'otherBodyRegion'
  | 'painTypes'
  | 'enteredBy'
  | 'notes'
> & {
  interventions: Array<Pick<Intervention, 'id' | 'type' | 'beforePain' | 'startedAtUtc'>>;
};

export type EntryDraft = {
  painLevel: number | null;
  bodyRegions: string[];
  otherBodyRegion: string;
  painTypes: string[];
  enteredBy: EnteredBy;
  notes: string;
  interventions: string[];
};

export const emptyDraft = (enteredBy: EnteredBy = 'self'): EntryDraft => ({
  painLevel: null,
  bodyRegions: [],
  otherBodyRegion: '',
  painTypes: [],
  enteredBy,
  notes: '',
  interventions: [],
});

export function labelForEnteredBy(value: EnteredBy) {
  return value === 'self' ? 'Cynthia' : 'Caregiver';
}

export function toggleItem(items: string[], item: string) {
  return items.includes(item) ? items.filter((value) => value !== item) : [...items, item];
}
